import {
    faUser,
    faExchangeAlt,
    faUserTimes,
    faCircle,
    faHistory,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import saveAs from "file-saver";
import { useState, useRef } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ColumnDescription } from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import AtendimentoCard from "../../../../Components/CardsPages/Atendimento";
import TransferirAtendimento from "../../../../Components/CardsPages/Atendimento/TransferirAtendimento";
import HistoricoCardPage from "../../../../Components/CardsPages/Historico";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import HTMLRemover from "../../../../Components/Utils/HTMLRemover";
import { useUserInfor } from "../../../../Context/User";
import {
    RemoverAtendimentoDoUsuarioController,
    ExcluirAtendimentoController,
} from "../../../../Controllers/AtendimentoCliente/Atendimento/AtendimentoControllers";
import { AtenderAtendimentoController } from "../../../../Controllers/Geral/Atendimentos/AtendimentosController";
import { ListarAtendimentosRepasseController } from "../../../../Controllers/Repasse/GestaoAtendimentos/GestaoAtendimentosRepasse";
import {
    LeituraUpdateExcelController,
    AlterarDadosExcelRepasseController,
} from "../../../../Controllers/Repasse/GestaoRepasse/GestaoRepasseController";
import { IAtendimentoCliente } from "../../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";
import {
    IAtendimentoRepasseRequest,
    TModoGestaoAtendimento,
} from "../../../../Interfaces/Repasse/AtendimentosRepasse/AtendimentosRepasse";
import { ACESSOS } from "../../../../Routes/Acessos";
import { FormatterCPF } from "../../../../Validations/InputMasks";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../../hooks/usePaginationFilter";
import { IPropsTableChange } from "../../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import StorageManagerCapys from "../../../../Tools/Storage";

const filtroInicial = {
    DS_NOME_CONTA: "",
    DS_NOME_CONTATO: "",
    DS_STATUS_CASO: "",
    DT_FINAL_FN: "",
    DT_FINAL_IN: "",
    DT_INICIAL_FN: "",
    DT_INICIAL_IN: "",
    FL_ANDAMENTO: 0,
    ID_ACOMPANHAMENTO: 0,
    ID_CASO: 0,
    ID_CATEGORIA_ATENDIMENTO: 0,
    ID_CONTA: 0,
    ID_EMPREENDIMENTO: "",
    ID_EQUIPE_VENDAS: 0,
    ID_ETAPA_CATEGORIA_ATENDIMENTO: "",
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: 0,
    ID_USUARIO_RESPONSAVEL: "",
    ID_USUARIO: 0,
    NR_CPF: "",
};

export default function useAtendimentoRepasse(
    atendimento: TModoGestaoAtendimento
) {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const [idEmpreendimentoOption, setIdEmpreendimentoOption] = useState<Array<{
        label: string;
        value: number;
    }> | null>(null);

    const filtroGestaoStorage =
        new StorageManagerCapys<IAtendimentoRepasseRequest>(
            `FILTRO_GESTAO_ATENDIMENTOS_REPASSE`,
            "session"
        );

    const { PageFilter, setPage, filter, setPageFilter, setFilter } =
        usePaginationFilter<IAtendimentoRepasseRequest>({
            filter: filtroGestaoStorage.get() ?? filtroInicial,
            page: 1,
        });

    const { UserInfor } = useUserInfor();

    const { execute: LeituraUpdateExcel, loading: leituraUpdateExcelLoading } =
        useAsyncCallback(async () => {
            ListarAtendimentosRepasseController(
                {
                    ...(PageFilter.filter ?? 0),
                    ID_CONTA: PageFilter.filter?.ID_CONTA ?? 0,
                    DT_FINAL_IN:
                        PageFilter.filter?.DT_FINAL_IN &&
                        PageFilter.filter?.DT_FINAL_IN?.length > 0
                            ? PageFilter.filter?.DT_FINAL_IN
                            : undefined,
                    DT_FINAL_FN:
                        PageFilter.filter?.DT_FINAL_FN &&
                        PageFilter.filter?.DT_FINAL_FN?.length > 0
                            ? PageFilter.filter?.DT_FINAL_FN
                            : undefined,
                    DT_INICIAL_IN:
                        PageFilter.filter?.DT_INICIAL_IN &&
                        PageFilter.filter?.DT_INICIAL_IN?.length > 0
                            ? PageFilter.filter?.DT_INICIAL_IN
                            : undefined,
                    DT_INICIAL_FN:
                        PageFilter.filter?.DT_INICIAL_FN &&
                        PageFilter.filter?.DT_INICIAL_FN?.length > 0
                            ? PageFilter.filter?.DT_INICIAL_FN
                            : undefined,
                    DS_NOME_CONTA:
                        PageFilter.filter?.DS_NOME_CONTA &&
                        PageFilter.filter?.DS_NOME_CONTA?.length > 0
                            ? PageFilter.filter?.DS_NOME_CONTA
                            : undefined,
                    DS_NOME_CONTATO:
                        PageFilter.filter?.DS_NOME_CONTATO &&
                        PageFilter.filter?.DS_NOME_CONTATO?.length > 0
                            ? PageFilter.filter?.DS_NOME_CONTATO
                            : undefined,
                    DS_STATUS_CASO:
                        PageFilter.filter?.DS_STATUS_CASO &&
                        PageFilter.filter?.DS_STATUS_CASO?.length > 0
                            ? PageFilter.filter?.DS_STATUS_CASO
                            : undefined,
                    ID_CASO:
                        PageFilter.filter?.ID_CASO &&
                        !isNaN(PageFilter.filter?.ID_CASO)
                            ? PageFilter.filter?.ID_CASO
                            : undefined,
                    ID_SUBCATEGORIA:
                        PageFilter.filter?.ID_SUBCATEGORIA &&
                        PageFilter.filter?.ID_SUBCATEGORIA > 0
                            ? PageFilter.filter?.ID_SUBCATEGORIA
                            : undefined,
                    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO:
                        PageFilter.filter
                            ?.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
                    ID_EMPREENDIMENTO:
                        idEmpreendimentoOption?.map(
                            (empreendimento) => empreendimento.value
                        ) ?? [],
                    FL_ANDAMENTO: PageFilter.filter?.FL_ANDAMENTO ?? 0,
                    ID_USUARIO:
                        PageFilter.filter?.ID_USUARIO &&
                        PageFilter.filter?.ID_USUARIO > 0
                            ? PageFilter.filter?.ID_USUARIO
                            : undefined,
                    ID_ACOMPANHAMENTO:
                        PageFilter.filter?.ID_ACOMPANHAMENTO &&
                        PageFilter.filter?.ID_ACOMPANHAMENTO > 0
                            ? PageFilter.filter?.ID_ACOMPANHAMENTO
                            : 0,
                    ID_TIPO_CANAL_ATENDIMENTO:
                        PageFilter.filter?.ID_TIPO_CANAL_ATENDIMENTO &&
                        PageFilter.filter?.ID_TIPO_CANAL_ATENDIMENTO > 0
                            ? PageFilter.filter?.ID_TIPO_CANAL_ATENDIMENTO
                            : 0,
                    // FL_CONTEM: naoContem,
                },
                0, //PageFilter.page,
                atendimento
            ).then(async (res) => {
                if (res)
                    await LeituraUpdateExcelController(
                        res.ATENDIMENTOS.map((caso: any) => caso.ID_CASO)
                    ).then((res) => {
                        saveAs(
                            new Blob([res], {
                                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            }),
                            "Template_Padrao.xlsx"
                        );
                    });
            });
        });

    const { execute: AlterarDadosExcel, loading: AlterarDadosExcelLoading } =
        useAsyncCallback(AlterarDadosExcelRepasseController);

    function handleAlterarDadosExcel(filePath: File) {
        const formData = new FormData();
        formData.append("file", filePath);
        AlterarDadosExcel(formData).then(() => {
            setShow(false);
            updateAtendimentos();
        });
    }

    const {
        value: lstAtendimentos,
        loading: lstAtendimentosLoading,
        execute: updateAtendimentos,
    } = useAsyncEffect(async () => {
        return ListarAtendimentosRepasseController(
            {
                ...(PageFilter.filter ?? 0),
                ID_CONTA: PageFilter.filter?.ID_CONTA ?? 0,
                DT_FINAL_IN:
                    PageFilter.filter?.DT_FINAL_IN &&
                    PageFilter.filter?.DT_FINAL_IN?.length > 0
                        ? PageFilter.filter?.DT_FINAL_IN
                        : undefined,
                DT_FINAL_FN:
                    PageFilter.filter?.DT_FINAL_FN &&
                    PageFilter.filter?.DT_FINAL_FN?.length > 0
                        ? PageFilter.filter?.DT_FINAL_FN
                        : undefined,
                DT_INICIAL_IN:
                    PageFilter.filter?.DT_INICIAL_IN &&
                    PageFilter.filter?.DT_INICIAL_IN?.length > 0
                        ? PageFilter.filter?.DT_INICIAL_IN
                        : undefined,
                DT_INICIAL_FN:
                    PageFilter.filter?.DT_INICIAL_FN &&
                    PageFilter.filter?.DT_INICIAL_FN?.length > 0
                        ? PageFilter.filter?.DT_INICIAL_FN
                        : undefined,
                DS_NOME_CONTA:
                    PageFilter.filter?.DS_NOME_CONTA &&
                    PageFilter.filter?.DS_NOME_CONTA?.length > 0
                        ? PageFilter.filter?.DS_NOME_CONTA
                        : undefined,
                DS_NOME_CONTATO:
                    PageFilter.filter?.DS_NOME_CONTATO &&
                    PageFilter.filter?.DS_NOME_CONTATO?.length > 0
                        ? PageFilter.filter?.DS_NOME_CONTATO
                        : undefined,
                DS_STATUS_CASO:
                    PageFilter.filter?.DS_STATUS_CASO &&
                    PageFilter.filter?.DS_STATUS_CASO?.length > 0
                        ? PageFilter.filter?.DS_STATUS_CASO
                        : undefined,
                ID_CASO:
                    PageFilter.filter?.ID_CASO &&
                    !isNaN(PageFilter.filter?.ID_CASO)
                        ? PageFilter.filter?.ID_CASO
                        : undefined,
                ID_SUBCATEGORIA:
                    PageFilter.filter?.ID_SUBCATEGORIA &&
                    PageFilter.filter?.ID_SUBCATEGORIA > 0
                        ? PageFilter.filter?.ID_SUBCATEGORIA
                        : undefined,
                ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO:
                    PageFilter.filter?.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
                ID_EMPREENDIMENTO:
                    idEmpreendimentoOption?.map(
                        (empreendimento) => empreendimento.value
                    ) ?? [],
                FL_ANDAMENTO: PageFilter.filter?.FL_ANDAMENTO ?? 0,
                ID_USUARIO:
                    PageFilter.filter?.ID_USUARIO &&
                    PageFilter.filter?.ID_USUARIO > 0
                        ? PageFilter.filter?.ID_USUARIO
                        : undefined,
                ID_ACOMPANHAMENTO:
                    PageFilter.filter?.ID_ACOMPANHAMENTO &&
                    PageFilter.filter?.ID_ACOMPANHAMENTO > 0
                        ? PageFilter.filter?.ID_ACOMPANHAMENTO
                        : 0,
                ID_TIPO_CANAL_ATENDIMENTO:
                    PageFilter.filter?.ID_TIPO_CANAL_ATENDIMENTO &&
                    PageFilter.filter?.ID_TIPO_CANAL_ATENDIMENTO > 0
                        ? PageFilter.filter?.ID_TIPO_CANAL_ATENDIMENTO
                        : 0,
                // FL_CONTEM: naoContem,
            },
            PageFilter.page,
            atendimento
        );
    }, [PageFilter.filter, PageFilter.page]);

    const totalPaginas = lstAtendimentos?.PAGINAS;

    const ultimaPesquisaRef = useRef("");
    const [pesquisaText, setPesquisaText] = useState("");
    // const [naoContem, setNaoContem] = useState<boolean>(true);

    function handleSearch(
        searchValue: string,
        newState: IPropsTableChange
        // contem: boolean
    ) {
        ultimaPesquisaRef.current = searchValue;

        setTimeout(() => {
            if (ultimaPesquisaRef.current === searchValue) {
                setFilter({
                    ...filter,
                    PESQUISA: newState.searchText,
                    // FL_CONTEM: naoContem,
                });
                setPage(newState.page);
            }
        }, 1500);
    }

    function rowAtendimento(cell: any, row: IAtendimentoCliente) {
        const atendimento = row.Atendimento;
        return (
            <AtendimentoCard
                atendimento={row}
                moduloAtendimento="Atendimento"
                setModal={setModal}
                setShow={setShow}
                adicionalButton={(row) => (
                    <>
                        {!row.DS_ATENDENTE && (
                            <button
                                className="btn btn-outline-warning btn-sm text-uppercase font-weight-bolder mt-5 mt-sm-0 mr-auto mr-sm-0 ml-sm-auto"
                                onClick={() => {
                                    AtenderAtendimentoController(
                                        row.ID_CASO
                                    ).then(() =>
                                        updateAtendimentos(
                                            {
                                                ...filter,
                                            },
                                            1,
                                            atendimento
                                        )
                                    );
                                }}
                            >
                                <FontAwesomeIcon icon={faUser} /> Atender
                            </button>
                        )}
                    </>
                )}
                atalhos={[
                    {
                        condition: (a) =>
                            !!a.DS_ATENDENTE &&
                            UserInfor.FUNCOES.some(
                                (f) =>
                                    f.NM_FUNCAO === "ADM_GERENCIAR_ATENDENTES"
                            ),
                        text: "Transferir Atendimento",
                        icon: faExchangeAlt,
                        action: (row) => {
                            const atendimento = row as IAtendimentoCliente;
                            setModal({
                                Component: () => (
                                    <TransferirAtendimento
                                        ID_CASO={row.ID_CASO}
                                        ID_TIPO_CASO={ACESSOS.REPASSE.ID_MODULO}
                                        setShow={setShow}
                                        update={() => {
                                            updateAtendimentos(
                                                filter,
                                                1,
                                                atendimento
                                            );
                                        }}
                                        ID_USUARIO={
                                            atendimento.Atendimento
                                                .ID_USUARIO_ACOMPANHAMENTO
                                        }
                                        ID_USUARIO_ACOMPANHAMENTO={
                                            atendimento.Atendimento
                                                .ID_USUARIO_ACOMPANHAMENTO
                                        }
                                    />
                                ),
                                IconHeader: faExchangeAlt,
                                headerComponent: "Transferir Atendimento",
                            });
                            setShow(true);
                        },
                    },
                    {
                        condition: (a) =>
                            !!a.DS_ATENDENTE &&
                            UserInfor.FUNCOES.some(
                                (f) =>
                                    f.NM_FUNCAO === "ADM_GERENCIAR_ATENDENTES"
                            ),
                        text: "Remover Atendente",
                        icon: faUserTimes,
                        action: () => {
                            Swal.fire({
                                title: `Deseja remover o vínculo de ${row.DS_ATENDENTE} a este atendimento?`,
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    RemoverAtendimentoDoUsuarioController(
                                        row.ID_CASO
                                    ).then(() => {
                                        updateAtendimentos(
                                            filter,
                                            1,
                                            atendimento
                                        );
                                    });
                                }
                            });
                        },
                    } /*{
                    text: 'Atender',
                    icon: faUser,
                    action: () => { 
                        AtenderAtendimentoController(row.ID_CASO)
                        .then(()=> updateAtendimentos({
                            ...filter
                        }, 1, atendimento))
                    },
                    condition: (a) => (!a.DS_ATENDENTE),
                    
                }*/,
                ]}
            >
                <div className="d-flex flex-grow-1 flex-column mt-3">
                    <label className="text-center text-dark font-weight-bold my-1 mr-5">
                        Atendimento
                    </label>
                    <div className="border-right border-left fixheigth border-3 border-danger">
                        <div className="d-flex flex-wrap align-items-center justify-content-center h-100">
                            <div className="px-4 py-3">
                                <div className="font-size-h5 font-weight-bolder text-center">
                                    <div className="font-size-sm text-muted font-weight-bold">
                                        Categoria
                                    </div>
                                    <label>
                                        {atendimento.DS_CATEGORIA_ATENDIMENTO}
                                    </label>
                                </div>
                            </div>
                            {atendimento.DS_SUBCATEGORIA && (
                                <div className="px-4 py-3">
                                    <div className="font-size-h5 font-weight-bolder text-center">
                                        <div className="font-size-sm text-muted font-weight-bold">
                                            Subcategoria
                                        </div>
                                        <label>
                                            {atendimento.DS_SUBCATEGORIA}
                                        </label>
                                    </div>
                                </div>
                            )}

                            <div className="px-4 py-3">
                                <div className="font-size-h5 font-weight-bolder text-center">
                                    <div className="font-size-sm text-muted font-weight-bold">
                                        Etapa
                                    </div>
                                    <label>
                                        {
                                            atendimento.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                        }
                                    </label>
                                </div>
                            </div>
                            <div className="px-4 py-3">
                                <div className="font-size-h5 font-weight-bolder text-center">
                                    <div className="font-size-sm text-muted font-weight-bold">
                                        SLA
                                    </div>
                                    <div>
                                        <FontAwesomeIcon
                                            icon={faCircle}
                                            size="1x"
                                            className={`text-${
                                                atendimento.NR_DIAS_ATRASO < 0
                                                    ? "success"
                                                    : atendimento.NR_DIAS_ATRASO ===
                                                      0
                                                    ? "warning"
                                                    : "danger"
                                            }`}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="px-4 py-3">
                                <div className="font-size-h5 font-weight-bolder text-center">
                                    <div className="font-size-sm text-muted font-weight-bold">
                                        SLO
                                    </div>
                                    <div>
                                        <FontAwesomeIcon
                                            icon={faCircle}
                                            size="1x"
                                            className={`text-${
                                                atendimento.NR_DIAS_ATRASO_SLO <
                                                0
                                                    ? "success"
                                                    : atendimento.NR_DIAS_ATRASO_SLO ===
                                                      0
                                                    ? "warning"
                                                    : "danger"
                                            }`}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </AtendimentoCard>
        );
    }
    //tabela
    //`${row.PESO_ATENDIMENTO.HX_COR_PESO_ATENDIMENTO} !important`
    const atendimentoColumns: Array<ColumnDescription> = [
        {
            dataField: "ID_CASO",
            text: "",
            isDummyField: true,
            formatter: rowAtendimento,
            headerClasses: "d-none",
        },
    ];
    const tableviewColumns: Array<ColumnDescription<IAtendimentoCliente>> = [
        {
            dataField: "Ver Caso",
            text: "",
            isDummyField: true,
            formatter: (_, row) => {
                const css = `
                .button-Capys-${row.PESO_ATENDIMENTO?.ID_TIPO_PESO_ATENDIMENTO} {
                    color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO} !important;
                    background-color: transparent;
                    border-color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO};
                }
                .button-Capys-${row.PESO_ATENDIMENTO?.ID_TIPO_PESO_ATENDIMENTO}:hover {
                    color: #ffffff !important;
                    background-color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO};
                    border-color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO};
                }
                .button-Capys-${row.PESO_ATENDIMENTO?.ID_TIPO_PESO_ATENDIMENTO} i {
                    color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO} !important;
                    background-color: transparent;
                    border-color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO};
                }
                .button-Capys-${row.PESO_ATENDIMENTO?.ID_TIPO_PESO_ATENDIMENTO}:hover i {
                    color: #ffffff !important;
                    background-color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO};
                    border-color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO};
                }
            `;
                return (
                    <>
                        <style>{css}</style>
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="ver-atendimento-tooltip">
                                    Ver Atendimento
                                </Tooltip>
                            }
                        >
                            <Link
                                to={ACESSOS.REPASSE.TELAS.ATENDIMENTO.DS_LINK(
                                    row.ID_CASO
                                )}
                                className={`m-2 btn btn-icon ${
                                    row.PESO_ATENDIMENTO
                                        ?.HX_COR_PESO_ATENDIMENTO
                                        ? `button-Capys-${row.PESO_ATENDIMENTO?.ID_TIPO_PESO_ATENDIMENTO}`
                                        : "btn-outline-info"
                                }`}
                            >
                                <i
                                    className={`icon-xl ${
                                        row.PESO_ATENDIMENTO
                                            ?.DS_ICON_PESO_ATENDIMENTO
                                            ? `${row.PESO_ATENDIMENTO?.DS_ICON_PESO_ATENDIMENTO}`
                                            : "far fa-eye"
                                    } `}
                                ></i>
                            </Link>
                        </OverlayTrigger>
                    </>
                );
            },
            style: (cell, row) => {
                if (row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO)
                    return {
                        borderLeft: `8px solid ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO}`,
                    };
                else return {};
            },
        },
        {
            dataField: "ID_CASO",
            text: "Protocolo",
        },
        {
            dataField: "CONTA.DS_NOME",
            text: "Cliente",
            classes: "p-2 ws-nowrap",
            formatter: (_, row) => {
                return (
                    <>
                        <h6 className="mb-0"> {row.CONTA.DS_NOME} </h6>
                        <label
                            className="mb-0"
                            style={{
                                color: row.PESO_ATENDIMENTO
                                    ?.HX_COR_PESO_ATENDIMENTO,
                            }}
                        >
                            {" "}
                            {
                                row.PESO_ATENDIMENTO?.DS_TIPO_PESO_ATENDIMENTO
                            }{" "}
                        </label>
                    </>
                );
            },
        },
        {
            dataField: "CONTA.DS_CONTATO",
            text: "Contato",
            classes: "p-2",
            formatter: (_, row) => (
                <div>
                    <div className="ws-nowrap"> {row?.CONTA.DS_CONTATO}</div>
                    <div className="ws-nowrap">
                        {row.CONTA.NR_CPF
                            ? FormatterCPF(row?.CONTA.NR_CPF)
                            : ""}
                    </div>
                </div>
            ),
        },
        {
            dataField: "DS_CASO",
            text: "Descrição",
            formatter: (c) => <HTMLRemover charLimit={40}>{c}</HTMLRemover>,
        },
        {
            dataField: "DT_INICIO",
            text: "Data Inicial",
            formatter: (c) => new Date(c).toLocaleDateString(),
        },
        {
            dataField: "DT_FIM",
            text: "Data Final",
            formatter: (c) => (c ? new Date(c).toLocaleDateString() : "-"),
        },
        {
            dataField: "DS_CANAL_ATENDIMENTO",
            text: "Canal de Atendimento",
        },

        {
            dataField: "DS_EMPREENDIMENTO",
            text: "Produto",
            // formatter: (c) =>
            //     `${c?.DS_EMPREENDIMENTO} - ${c?.UNIDADE?.DS_UNIDADE}`,
        },
        {
            dataField: "Atendimento.DS_CATEGORIA_ATENDIMENTO",
            text: "Categoria",
        },
        {
            dataField: "DS_ATENDENTE",
            text: "Atendente",
        },
        {
            dataField: "Atendimento.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO",
            text: "Etapa",
        },
        {
            dataField: "Atendimento.NR_DIAS_ATRASO",
            text: "SLA",
            formatter: (c) => (
                <OverlayTrigger
                    overlay={
                        <Tooltip id="ver-atendimento-tooltip">
                            {" "}
                            {c < 0 ? (
                                <>{Math.abs(c)} Dias para Vencer</>
                            ) : (
                                <>{c} Dias em Atraso SLA</>
                            )}
                        </Tooltip>
                    }
                >
                    <FontAwesomeIcon
                        icon={faCircle}
                        size="1x"
                        className={`text-${
                            c < 0 ? "success" : c === 0 ? "warning" : "danger"
                        }`}
                    />
                </OverlayTrigger>
            ),
        },
        {
            dataField: "Atendimento.NR_DIAS_ATRASO_SLO",
            text: "SLO",
            formatter: (c) => (
                <OverlayTrigger
                    overlay={
                        <Tooltip id="ver-atendimento-tooltip">
                            {" "}
                            {c} Dias em Atraso SLO
                        </Tooltip>
                    }
                >
                    <FontAwesomeIcon
                        icon={faCircle}
                        size="1x"
                        className={`text-${
                            c < 0 ? "success" : c === 0 ? "warning" : "danger"
                        }`}
                    />
                </OverlayTrigger>
            ),
        },
        {
            dataField: "",
            text: "",
            isDummyField: true,
            formatter: (_, row) => (
                <div className="d-flex g-2 p-2">
                    <OverlayTrigger
                        overlay={
                            <Tooltip id="historico-tooltip">
                                Histórico do Caso
                            </Tooltip>
                        }
                    >
                        <button
                            className="btn btn-icon btn-outline-primary"
                            onClick={() => {
                                setModal({
                                    Component: () =>
                                        HistoricoCardPage({
                                            ID_CASO: row.ID_CASO,
                                        }),
                                    headerComponent: "Históricos",
                                    IconHeader: faHistory,
                                    collapseForm: true,
                                    size: "lg",
                                });
                                setShow(true);
                            }}
                        >
                            <FontAwesomeIcon icon={faHistory} />
                        </button>
                    </OverlayTrigger>
                    <div>
                        {UserInfor.FUNCOES.some(
                            (f) => f.NM_FUNCAO === "ADM_GERENCIAR_ATENDENTES"
                        ) && (
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="transferir-tooltip">
                                        Transferir Atendimento
                                    </Tooltip>
                                }
                            >
                                <button
                                    className="btn btn-icon btn-outline-warning"
                                    onClick={() => {
                                        setModal({
                                            Component: () => (
                                                <TransferirAtendimento
                                                    ID_CASO={row.ID_CASO}
                                                    ID_TIPO_CASO={
                                                        ACESSOS.REPASSE
                                                            .ID_MODULO
                                                    }
                                                    setShow={setShow}
                                                    update={() => {
                                                        updateAtendimentos(
                                                            filter,
                                                            1,
                                                            atendimento
                                                        );
                                                    }}
                                                    ID_USUARIO={
                                                        row.Atendimento
                                                            .ID_USUARIO
                                                    }
                                                    ID_USUARIO_ACOMPANHAMENTO={
                                                        row.Atendimento
                                                            .ID_USUARIO_ACOMPANHAMENTO
                                                    }
                                                />
                                            ),
                                            IconHeader: faExchangeAlt,
                                            headerComponent:
                                                "Transferir Atendimento",
                                        });
                                        setShow(true);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faExchangeAlt} />
                                </button>
                            </OverlayTrigger>
                        )}
                    </div>
                    {!row.DS_ATENDENTE ? (
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="atender-tooltip">Atender</Tooltip>
                            }
                        >
                            <button
                                className="btn btn-icon btn-outline-success"
                                onClick={() => {
                                    AtenderAtendimentoController(
                                        row.ID_CASO
                                    ).then(() =>
                                        updateAtendimentos(
                                            {
                                                ...filter,
                                            },
                                            1,
                                            atendimento
                                        )
                                    );
                                }}
                            >
                                <FontAwesomeIcon icon={faUser} />
                            </button>
                        </OverlayTrigger>
                    ) : (
                        <div>
                            {UserInfor.FUNCOES.some(
                                (f) =>
                                    f.NM_FUNCAO === "ADM_GERENCIAR_ATENDENTES"
                            ) && (
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="remover-tooltip">
                                            Remover Atendente
                                        </Tooltip>
                                    }
                                >
                                    <button
                                        className="btn btn-icon btn-outline-danger"
                                        onClick={() => {
                                            Swal.fire({
                                                title: `Deseja remover o vínculo de ${row.DS_ATENDENTE} a este atendimento?`,
                                                icon: "info",
                                                buttonsStyling: false,
                                                confirmButtonText:
                                                    "<i class='la la-check'></i> Sim!",
                                                showCancelButton: true,
                                                cancelButtonText:
                                                    "<i class='la la-thumbs-down'></i> Não",
                                                customClass: {
                                                    confirmButton:
                                                        "btn btn-outline-success",
                                                    cancelButton:
                                                        "btn btn-default",
                                                },
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    RemoverAtendimentoDoUsuarioController(
                                                        row.ID_CASO
                                                    ).then(() => {
                                                        updateAtendimentos(
                                                            filter,
                                                            1,
                                                            atendimento
                                                        );
                                                    });
                                                }
                                            });
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faUserTimes} />
                                    </button>
                                </OverlayTrigger>
                            )}
                        </div>
                    )}
                    {UserInfor.FUNCOES.some(
                        (f) => f.NM_FUNCAO === "ADM_EXCLUIR_CASO"
                    ) && (
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="historico-tooltip">
                                    Excluir Atendimento
                                </Tooltip>
                            }
                        >
                            <button
                                className="btn btn-icon btn-outline-dark"
                                onClick={() => {
                                    Swal.fire({
                                        title: `Deseja excluir esse Atendimento? <br/> <br/> Caso: ${row.ID_CASO}`,
                                        icon: "info",
                                        buttonsStyling: false,
                                        confirmButtonText:
                                            "<i class='la la-check'></i> Sim!",
                                        showCancelButton: true,
                                        cancelButtonText:
                                            "<i class='la la-thumbs-down'></i> Não",
                                        customClass: {
                                            confirmButton:
                                                "btn btn-outline-success",
                                            cancelButton: "btn btn-default",
                                        },
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            ExcluirAtendimentoController(
                                                row.ID_CASO,
                                                UserInfor.ID_USUARIO ?? 0
                                            ).then(() => {
                                                updateAtendimentos(
                                                    1,
                                                    atendimento
                                                );
                                            });
                                        }
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} />
                            </button>
                        </OverlayTrigger>
                    )}
                </div>
            ),
        },
    ];

    return {
        show,
        setShow,
        modal,
        setModal,
        filtroGestaoStorage,
        filtroInicial,
        idEmpreendimentoOption,
        setIdEmpreendimentoOption,
        PageFilter,
        setPage,
        filter,
        setPageFilter,
        setFilter,
        UserInfor,
        LeituraUpdateExcel,
        leituraUpdateExcelLoading,
        AlterarDadosExcel,
        AlterarDadosExcelLoading,
        handleAlterarDadosExcel,
        lstAtendimentos,
        lstAtendimentosLoading,
        updateAtendimentos,
        totalPaginas,
        pesquisaText,
        setPesquisaText,
        handleSearch,
        atendimentoColumns,
        tableviewColumns,
    };
}
